import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import classNames from 'classnames';
import Image from 'next/image';
import { FunctionComponent } from 'react';

import useIsArticlePageRedesignUnifiedUXEnabled from '../../../hooks/useIsArticlePageRedesignUnifiedUXEnabled';

import css from './index.module.scss';

export const ThankYouMessage: FunctionComponent = () => {
  const { t } = useTranslation();
  const isCopilotRedesign = useIsArticlePageRedesignUnifiedUXEnabled();

  return (
    <Box
      className={classNames(css.thankYouContainer, {
        [css.copilotRedesign]: isCopilotRedesign,
      })}
    >
      <Text className={css.thankYouText}>
        {t('article-feedback.improved-feedback.message.thank-you-helpful')}
      </Text>
      <Image
        src="https://static.parastorage.com/services/kb-client-nextjs/dist/public/images/icons/smile.svg"
        alt="smile"
        width={18}
        height={18}
        className={css.smileIcon}
        priority
        loading="eager"
      />
    </Box>
  );
};
